import { getAPIURL, getAPIQuery } from './config.js';

export let getPageData = async () => {

    const url = getAPIURL();
    const query = getAPIQuery();
    const opts = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query })
    };

    const response = await fetch(url, opts);
    const json = await response.json();

    if (response.ok) {
        //console.log("Server JSON: ", json);

        trackPage(json.data.entry[0].pageTitle);

        return {
            pageTitle: json.data.entry[0].pageTitle,
            pageContent: json.data.entry[0].pageContent
        };
        
    } else {
        alert("HTTP-Error: " + response.status);
    }

}

export function trackPage(pageTitle) {
    
    const GATrackingID = 'UA-8727745-1';
	const GAUrlPath = '/automated-sample-management/microsite/' + pageTitle.replace(/\s+/g, '-').toLowerCase();

    gtag('config', GATrackingID, {
        'title' : pageTitle,
        'page_location' : GAUrlPath,
        'page' : GAUrlPath
    });
}